<template>
  <div>
    <v-card style="width:100%;padding:10px;">
      <v-layout row wrap style="height:40px;">
        <v-flex xs12 style="padding-top:8px">
          <v-btn class="success searchbtn" @click="fetchstatement">Search</v-btn>
          <v-menu
            :close-on-content-click="false"
            v-model="menu2"
            lazy
            transition="scale-transition"
            offset-y
            style="float:right"
          >
            <input
              type="text"
              slot="activator"
              v-model="date2"
              readonly
              class="search"
              placeholder="To Date"
            />
            <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
          </v-menu>
          <v-menu
            :close-on-content-click="false"
            v-model="menu1"
            lazy
            transition="scale-transition"
            offset-y
            style="float:right"
          >
            <input
              type="text"
              slot="activator"
              v-model="date1"
              readonly
              class="search"
              placeholder="From Date"
            />
            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
          </v-menu>
          <input type="number" class="search" v-model="mobile" placeholder="Enter Number" />
        </v-flex>
        <v-layout row wrap>
          <v-spacer></v-spacer>
        </v-layout>
      </v-layout>
    </v-card>
    <v-data-table :headers="headers" :items="statementlist" :search="search">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderid }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.mobile }}</td>
        <td>{{ props.item.bank_txtid }}</td>
        <td>{{ props.item.amount }}</td>
        <td>
          <v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn>
        </td>
        <td>{{ props.item.tid }}</td>
        <td>{{ props.item.time}}</td>
        <td>{{ props.item.remark }}</td>
        <td>
          <v-btn @click="getsummary(props.item)" small color="primary">View</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewstatus" width="400">
      <v-card>
        <v-card-title style="height:40px">
          <span class="body-2">Summary of your Order</span>
        </v-card-title>
        <v-card-text style="padding-top:0px">
          <v-layout row wrap v-for="(item,key) in summary" :key="key">
            <v-flex xs6>
              <v-card-text class="px-0">{{key}}</v-card-text>
            </v-flex>
            <v-flex xs6>
              <v-card-text class="px-0">{{item}}</v-card-text>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      modal: false,
      date1: moment().format("YYYY-MM-DD"),
      menu1: false,
      date2: moment().format("YYYY-MM-DD"),
      menu2: false,
      headers: [
        { text: "Order No", value: "orderno", align: "left" },
        { text: "name", value: "name" },
        { text: "MobileNo", value: "mobile" },
        { text: "Bank Transaction ID", value: "bank_txtid" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "status" },
        { text: "TransactionID", value: "transactionid" },
        { text: "Recharge Time", value: "time" },
        { text: "Remark", value: "remark" },
        { text: "Action", value: "action" }
      ],
      dialog: false,
      viewstatus: false,
      statementlist: [],
      modal: false,
      search: "",
      summary: {},
      mobile: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    dmr() {
      return this.$store.getters.ezpay;
    }
  },
  watch: {
    dmr(val) {
      if (val != null) {
        this.fetchstatement();
        this.mobile = val.mobile_no;
      }
    }
  },
  methods: {
    checkstatus(status) {
      status = status.toLowerCase();
      if (status == "success") return "success";
      if (status == "pending") return "grey";
      if (status == "inprocess") return "warning";
      if (status == "failed") return "error";
      return "primary";
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    pushstatement(value) {
      let vm = this;
      vm.statementlist = [];
      for (let i = 0; i < value.length; i++) {
        let doc = value[i];
        let time = doc.date_time.replace("/Date(", "").replace(")/", "");
        vm.statementlist.push({
          amount: doc.amount,
          orderid: doc.rechargeid,
          mobile: vm.mobile,
          time: time,
          name: doc.name,
          remark: doc.remark,
          status: doc.status,
          bank_txtid: doc.bank_txid,
          tid: doc.transaction_id
        });
      }
    },
    getsummary(doc) {
      let vm = this;
      vm.viewstatus = true;
      vm.summary = {
        "Order No": doc.orderid,
        "Name ": doc.name,
        Mobile: doc.mobile,
        Amount: doc.amount,
        Status: doc.status,
        Time: doc.time,
        "Bank Transaction Id": doc.bank_txtid,
        "Transaction Id": doc.tid
      };
    },
    fetchstatement() {
      let vm = this;
      if (!vm.user.phone)
        return vm.notification("warn", "Authentication Required!");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        recordcnt: "50",
        getFromdate: vm.date1,
        getTodate: vm.date2,
        Validate_MobileNo: vm.mobile
      };
      vm.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: "DMTF_History",
          type: "ezpay",
          data: doc
        })
        .then(function(res) {
          vm.dialog = false;
          vm.pushstatement(res.data);
        })
        .catch(function(error) {
          vm.notification("error", error.message);
          vm.dialog = false;
        });
    }
  },
  mounted() {
    let vm = this;
  }
};
</script>


<style scoped>
.search {
  width: 150px;
  float: right;
  height: 34px;
  background: white;
  border: 1px solid lightgray;
  outline: none;
  margin-left: 20px;
  padding-left: 10px;
  font-size: 1em;
}
.searchbtn {
  margin-right: 15px;
  height: 34px;
  margin-left: 20px;
  float: right;
  margin-top: 0px;
}
</style>

